import { render, staticRenderFns } from "./DownloadByArea.vue?vue&type=template&id=036f24fe&scoped=true"
import script from "./DownloadByArea.vue?vue&type=script&lang=js"
export * from "./DownloadByArea.vue?vue&type=script&lang=js"
import style0 from "./DownloadByArea.vue?vue&type=style&index=0&id=036f24fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f24fe",
  null
  
)

export default component.exports